/**
 * 定义 webview 标题功能
 * 目前适用于随手记
 */
import useragent from '@common/useragent'
import { call, uriSuishouji } from './bridge'
import { compare } from './version'
import { set as clientTitle } from './title'

// 是否可以使用标题居中
export const canApplyCustomizeTitle = () => {
  // 随手记导航栏标题居中特性版本号
  const SUISHOUJI_ANDROID = '10.7.2.5'
  const SUISHOUJI_IOS = '11.4.4'
  if ((useragent.isAndroid && compare(SUISHOUJI_ANDROID)) || (useragent.isIOS && compare(SUISHOUJI_IOS))) {
    return true
  }

  return false
}

const requestCustomizeTitle = (opts) => {
  if (useragent.isSuishouji) {
    if (canApplyCustomizeTitle()) {
      call(uriSuishouji('requestCustomizeTitle', opts))
      // 需要设置页面title为空格
      clientTitle(' ')
    } else {
      // 不支持标题居中，需要设置页面title
      clientTitle(opts.title)
    }
  } else {
    // 其他渠道设置页面title
    clientTitle(opts.title)
  }
}

export default requestCustomizeTitle

/*
* @param {String} title 标题
* @param {String} textAlign 位置，默认居中，还可以设置成'left'，在返回箭头左边
*/
export const setTitle = (title, textAlign = 'center') => {
  requestCustomizeTitle({
    title,
    'text-align': textAlign
  })
}